console.log(JSON.stringify(process.env));

const config = {
  mockIddComponents: process.env['REACT_APP_MOCK_IDD_COMPONENTS'] === '1'
}
export default config;
